<a
  class="clear-link"
  [routerLink]="
    slug() != null
      ? ['/', language, 'eventnow', slug(), 'auction', auction().idAuction]
      : ['/', language, 'auction', auction().slug]
  "
  (click)="goToArticle()"
  aria-label="Go to auction details"
>
  <article
    class="bid"
    [class.bidBox]="!isBranded()"
    [class.bidBoxBranded]="isBranded()"
    [class.disabled]="
      auction().buyItNow && auction().articleQty < 1 && idEvent !== -1
    "
    [class.bidBoxEvidence]="isHomepageEvidence"
  >
    <header
      *ngIf="isMemorabid && !auction().isPreEvent"
      class="bidHeader bidHeaderGold text-uppercase"
      [class.bidHeaderEvidence]="isHomepageEvidence"
      [class.bidPreEvent]="auction().isPreEvent"
    >
      {{ "IDS_SELLER_MEMORABID" | translate }}
    </header>
    <header
      *ngIf="!isMemorabid && !auction().isPreEvent"
      class="bidHeader bidHeaderMarketplace text-uppercase"
      [class.bidHeaderEvidence]="isHomepageEvidence"
      [class.bidPreEvent]="auction().isPreEvent"
    >
      {{ "IDS_SELLER" | translate }} {{ auction().entityDescription }}
    </header>
    <header
      *ngIf="auction().isPreEvent"
      class="bidHeader bidPreEvent text-uppercase"
      [class.bidHeaderEvidence]="isHomepageEvidence"
    >
      {{ "IDS_PRE_EVENT_NOW" | translate }}
    </header>
    <div
      #imageShowcase
      class="imageShowcase"
      [ngClass]="{
        imageShowcaseEvidence: isHomepageEvidence,
      }"
    >
      <div class="image-container">
        <img
          class="articleImage"
          src="{{
            auction().articlePhoto != null && auction().articlePhoto.fullPath !== ''
              ? auction().articlePhoto.fullPath + '?w=' + imageWidth
              : '/assets/img/not-found.png'
          }}"
          loading="lazy"
          alt="cover image of the auction item"
        />
        <div
          class="overlay"
          *ngIf="idEvent !== -1 && auction().buyItNow && auction().articleQty < 1"
        ></div>
        <img
          src="/assets/img/sold-out.png"
          alt="sold out"
          class="sold-out"
          *ngIf="idEvent !== -1 && auction().buyItNow && auction().articleQty < 1"
        />
      </div>

      <img
        *ngIf="isMemorabid"
        class="bidImageTopLeft"
        src="/assets/img/memorabid-icon.svg"
        alt="Memorabid"
        loading="lazy"
      />
      <span *ngIf="authService.isAuthenticated()">
        <button
          type="button"
          class="bidImageTopRight"
          [ngClass]="{
            bidImageTopRightMarketplace: !isMemorabid && !auction().isPreEvent,
            bidImageTopRightGold: isMemorabid && !auction().isPreEvent,
            bidImageTopRightPreEvent: auction().isPreEvent
          }"
          (click)="onToggleWishlist($event)"
          aria-label="Toggle wishlist"
        >
          <fa-icon
            [icon]="!isStarred() ? faHeartRegular : faHeart"
            size="lg"
          ></fa-icon>
        </button>
      </span>
      <div
        *ngIf="isHomepageEvidence && daysToEnd >= 1"
        class="bidImageBottomLeft"
        [ngClass]="{ 'move-up': auction().hasUserBided && !auction().isFinished }"
      >
        <div class="bid-info-icon">
          <fa-icon [icon]="faStar" size="sm"></fa-icon>
        </div>
        <span class="bidImageText text-uppercase">{{
          "IDS_GREAT_EXCLUSIVE" | translate
        }}</span>
      </div>
      <div
        *ngIf="
          daysToEnd < 1 &&
          timeDifferenceFromStart > 0 &&
          secondsToEnd >= 0 &&
          idEvent === -1 &&
          !auction().buyItNow
        "
        class="bidImageBottomLeft expired"
        [ngClass]="{ 'move-up': auction().hasUserBided && !auction().isFinished }"
      >
        <div class="bid-info-icon">
          <fa-icon [icon]="faFlag" size="sm"></fa-icon>
        </div>
        <span class="bidImageText text-uppercase">{{
          "IDS_EXPIRING" | translate
        }}</span>
      </div>
      <div
        *ngIf="auction().hasUserBided"
        class="user-bid-label"
        [ngClass]="{
          outbid: !auction().isUserBestBider,
          reserveNotReached:
            auction().isUserBestBider && !auction().reservePriceReached
        }"
      >
        {{
          (auction().isUserBestBider
            ? auction().reservePriceReached
              ? "IDS_GRID_USER_BIDED"
              : "IDS_GRID_RESERVE_NOT_REACHED"
            : "IDS_GRID_USER_OUTBID"
          ) | translate
        }}
      </div>
    </div>
    <ng-container
      *ngTemplateOutlet="
        isHomepageEvidence ? bidDetailsEvidence : bidDetailsDefault
      "
    ></ng-container>
  </article>
</a>

<ng-template #bidDetailsDefault>
  <div class="d-flex flex-column justify-content-between h-100 mt-2">
    <ng-container *ngTemplateOutlet="title" />
    <div class="bid-details">
      <div class="bid-properties" *ngIf="idEvent == -1">
        {{ auction().articleProperties[1] }}
        <span
          *ngIf="
            !!auction().articleProperties[1] && !!auction().articleProperties[0]
          "
          >|</span
        >
        {{ auction().articleProperties[0] }}
      </div>
      <div *ngIf="idEvent == -1 && !auction().buyItNow">
        <div
          class="bid-description"
          *ngIf="(secondsToEnd > 0 || secondsToEnd == 0) && idEvent == -1"
        >
          <span class="text-uppercase">
            {{
              (timeDifferenceFromStart > 0
                ? "IDS_EXPIRES_IN"
                : "IDS_STARTING_IN"
              ) | translate
            }}
          </span>

          <span *ngIf="daysToEnd > 0" class="time timeGreen">
            {{ daysToEnd }}
            {{ (daysToEnd == 1 ? "IDS_DAY" : "IDS_DAYS") | translate }}
          </span>

          <span *ngIf="daysToEnd < 1 && hoursToEnd >= 1" class="time timeRed">
            {{ hoursToEnd }}
            {{ (hoursToEnd == 1 ? "IDS_HOUR" : "IDS_HOURS") | translate }}
          </span>

          <span
            *ngIf="daysToEnd < 1 && hoursToEnd < 1 && minutesToEnd >= 1"
            class="time timeRed"
          >
            {{ minutesToEnd }}
            {{ (minutesToEnd == 1 ? "IDS_MINUTE" : "IDS_MINUTES") | translate }}
          </span>

          <span
            *ngIf="daysToEnd < 1 && hoursToEnd < 1 && minutesToEnd < 1"
            class="time timeRed"
          >
            {{ secondsToEnd }}
            {{ (secondsToEnd == 1 ? "IDS_SECOND" : "IDS_SECONDS") | translate }}
          </span>
        </div>
        <div *ngIf="secondsToEnd < 0 && idEvent == -1 && !showCoverReserveButton() && !showProposal()" class="d-flex">
          <span class="time timeRed text-uppercase ps-0"
            ><b>{{ "IDS_EXPIRED" | translate }}</b></span
          >
        </div>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="footer" />
  </div>
</ng-template>

<ng-template #bidDetailsEvidence>
  <div class="d-flex align-items-end h-100">
    <div class="d-flex flex-column w-100 h-100 pt-2">
      <ng-container *ngTemplateOutlet="title" />
      <div class="bid-details">
        <div class="bid-properties">
          {{ auction().articleProperties[1] }} |
          {{ auction().articleProperties[0] }}
        </div>
      </div>
      <ng-container *ngTemplateOutlet="footer" />
    </div>
    <div *ngIf="!auction().buyItNow" class="bid-evidence-timer-container">
      <div
        *ngIf="secondsToEnd >= 0"
        class="bid-evidence-timer"
        [ngClass]="{ expiring: daysToEnd < 1 }"
      >
        <span class="text-uppercase mt-2">
          <fa-icon class="me-2" [icon]="faCalendarAlt"></fa-icon>
          <b>{{
            (timeDifferenceFromStart > 0
              ? "IDS_EXPIRES_IN_MOBILE"
              : "IDS_STARTING_IN"
            ) | translate
          }}</b>
        </span>

        <div
          class="bid-evidence-timer-counter"
          *ngIf="daysToEnd > 0 && secondsToEnd >= 0"
        >
          <span class="number text-uppercase">
            <b>{{ daysToEnd }}</b>
          </span>
          <span class="label text-uppercase">
            <b>{{ (daysToEnd == 1 ? "IDS_DAY" : "IDS_DAYS") | translate }}</b>
          </span>
        </div>

        <div
          class="bid-evidence-timer-counter"
          *ngIf="daysToEnd < 1 && hoursToEnd >= 1 && secondsToEnd >= 0"
        >
          <span class="number text-uppercase">
            <b>{{ hoursToEnd }}</b>
          </span>
          <span class="label text-uppercase">
            <b>{{
              (hoursToEnd == 1 ? "IDS_HOUR" : "IDS_HOURS") | translate
            }}</b>
          </span>
        </div>

        <div
          class="bid-evidence-timer-counter"
          *ngIf="
            daysToEnd < 1 &&
            hoursToEnd < 1 &&
            minutesToEnd >= 1 &&
            secondsToEnd >= 0
          "
        >
          <span class="number text-uppercase">
            <b>{{ minutesToEnd }}</b>
          </span>
          <span class="label text-uppercase">
            <b>{{
              (minutesToEnd == 1 ? "IDS_MINUTE" : "IDS_MINUTES") | translate
            }}</b>
          </span>
        </div>

        <div
          class="bid-evidence-timer-counter"
          *ngIf="
            daysToEnd < 1 &&
            hoursToEnd < 1 &&
            minutesToEnd < 1 &&
            secondsToEnd >= 0
          "
        >
          <span class="number text-uppercase">
            <b>{{ secondsToEnd }}</b>
          </span>
          <span class="label text-uppercase">
            <b>{{
              (secondsToEnd == 1 ? "IDS_SECOND" : "IDS_SECONDS") | translate
            }}</b>
          </span>
        </div>
      </div>

      <div *ngIf="secondsToEnd < 0" class="bid-evidence-timer expired">
        <span class="text-uppercase">
          <b>{{ "IDS_EXPIRED" | translate }}</b>
        </span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #title>
  <div
    class="bid-title-container"
    [ngClass]="{ 'bid-title-evidence': isHomepageEvidence }"
  >
    <span
      class="bid-title"
      [ngClass]="[
        auction().isPreEvent ? 'pre-event' : isMemorabid ? 'memorabid' : 'marketplace'
      ]"
    >
      {{ auction().title }}
    </span>
  </div>
</ng-template>

<ng-template #footer>
  <footer
    class="bid-footer"
    [ngClass]="{
      'pre-event': auction().isPreEvent,
      'memorabid': isMemorabid && !auction().isPreEvent && !showProposal() && !showCoverReserveButton(),
      'marketplace': !isMemorabid && !auction().isPreEvent && !showProposal() && !showCoverReserveButton()

    }"
  >
    <div *ngIf="showProposal()" class="proposal-button-container">
      <button
        class="btn btn-primary proposal-button"
        [ngClass]="{
          'proposal-button-memorabid': isMemorabid,
          'proposal-button-marketplace': !isMemorabid,
        }"
        (click)="openProposalPopup($event)"
        type="button"
      >
        <span class="web">
          {{ "IDS_SEND_PROPOSAL_WEB" | translate }}
        </span>
        <span class="mobile">
          {{ "IDS_SEND_PROPOSAL_MOBILE" | translate }}
        </span>
      </button>
    </div>
    <div *ngIf="!showProposal() && showCoverReserveButton()" class="proposal-button-container">
      <button
        class="btn btn-primary proposal-button reserve"
        (click)="openCoverReservePopup($event)"
        type="button"
      >
          {{ "IDS_COVER_RESERVE" | translate }}
      </button>
    </div>
    <div *ngIf="!showProposal() && !showCoverReserveButton()" class="bid-text-content">
      <span>
        {{
          auction().currentMaxOfferedPrice ?? auction().basePrice
            | number : "1.0-0" : "it"
        }}
        €
      </span>
    </div>

    <div class="bid-text-label text-uppercase" *ngIf="auction().buyItNow">
      {{
        auction().articleQty > 0
          ? "Buy now"
          : ((idEvent === -1 ? "IDS_SOLD_OUT" : "IDS_AWARDED_AUCTION_1")
            | translate)
      }}
    </div>
  </footer>
</ng-template>
